import styled from 'styled-components';

export const Content = styled.main`
  padding: 0px 0px 0px 340px;
  min-height: 600px;

  @media (max-width: 1024px) {
    padding: 60px 0px 0px 0px;
    overflow-x: hidden;
  }
`;

export const Info = styled.div`
  width: 100%;
  float: left;
  padding: 15px;

  div {
    width: 100%;
    float: left;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    background: rgba(151, 153, 153, 0.08);
    border: ${({ theme }) => `1px solid ${theme.colors.BORDER}`};
    border-radius: 10px;
    padding: 25px;
    margin: 0px 0 0 0;

    h1 {
      font-size: 26px;
    }

    p {
      margin: 0 0 10px 0;
      color: ${({ theme }) => theme.colors.TEXT1};
      font-size: 14px;
    }
  }

  @media (max-width: 1024px) {
  }
`;

export const MyZone = styled.div`
  float: left;
  width: 100%;

  @media (max-width: 1024px) {
  }
`;

export const OtherZone = styled.div`
  float: left;
  width: 100%;
  background: rgba(80, 103, 230, 0.02);
  border-left: 5px solid rgba(80, 103, 230, 0.8);

  @media (max-width: 1024px) {
  }
`;

export const Block = styled.div`
  float: left;
  width: 100%;
  padding-bottom: 40px;
  border-bottom: 2px solid rgba(0, 0, 0, 0.1);
  padding: 40px 20px 40px 30px;

  h1 {
    float: left;
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    margin: 0 0 40px 0;

    i {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 40px;
      height: 40px;
      background: ${({ theme }) => theme.colors.LIGHT2};
      border-radius: 10px;
    }

    span {
      font-size: 22px;
      float: left;
      margin-left: 10px;
      color: ${({ theme }) => theme.colors.TEXT1};
    }
  }

  main {
    float: left;
    width: 100%;
    display: flex;
    flex-direction: row;

    > h2 {
      background: #333;
      width: 3rem;
      height: 3rem;
      border-radius: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      color: ${({ theme }) => theme.colors.TEXT1};
      text-align: center;
      font-size: 22px;
      font-weight: 700;
      margin: 0 10px 0 0;
    }
  }

  table {
    border: ${({ theme }) => `1px solid ${theme.colors.BORDER}`};
    border-radius: 10px;
    margin-bottom: 20px;
  }

  &:last-child {
    border-bottom: none;
  }

  .finance-r {
    text-align: right;
  }

  .info {
    width: 100%;
    float: left;
    display: flex;
    flex-direction: row;
    align-items: center;
    background: ${({ theme }) => theme.colors.LIGHT1};
    border: ${({ theme }) => `1px solid ${theme.colors.BORDER}`};
    border-radius: 10px;
    padding: 15px;
    margin: 0px 0 0 0;

    i {
      width: 40px;
      height: 40px;
      background: ${({ theme }) => theme.colors.LIGHT1};
      border: ${({ theme }) => `1px solid ${theme.colors.BORDER}`};
      align-items: center;
      display: flex;
      flex-direction: row;
      justify-content: center;
      border-radius: 20px;
    }

    p {
      width: 100%;
      float: left;
      text-align: left;
      padding: 0 10px;
      color: ${({ theme }) => theme.colors.TEXT1};
      font-size: 16px;
    }
  }

  @media (max-width: 1024px) {
    padding: 10px;

    h1 {
      span {
        font-size: 14px;
      }
    }

    .info {

      padding: 10px;
      align-items: center;
      justify-content: center;

      i {
        width: 20px;
      }

      p {
        margin: 0;
        font-size: 10px;
        font-weight: 700;
      }
    }
  }
`;

export const Thumb = styled.div`
  float: left;
  width: 50px;
  overflow: hidden;
  border-radius: 100%;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: ${({ theme }) => `1px solid ${theme.colors.BORDER}`};
  box-shadow: ${({ theme }) => `1px 5px 5px ${theme.colors.SHADOW}`};
  background: ${({ theme }) => theme.colors.LIGHT1};

  span {
    font-size: 22px;
    color: ${({ theme }) => theme.colors.TEXT1};
    font-weight: 700;
    text-transform: uppercase;
  }

  img {
    max-width: 90px;
    max-height: 90px;
    float: left;
    min-width: 60px;
    min-height: 60px;
  }

  @media (max-width: 1024px) {
    width: 40px;
    height: 40px;
     border-width: 2px;

    span {
      font-size: 16px;
    }
  }

`;